import PropTypes from "prop-types";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ClockCircleFilled,
} from "@ant-design/icons";

import "./styles.less";

const StatusBlock = (props) => {
  const { status, showText = false } = props;
  const statusConfig = {
    NEW: {
      icon: <ClockCircleFilled style={{ color: "#faad14", fontSize: 22 }} />,
      text: "Đang chờ",
    },
    CANCEL: {
      icon: <CloseCircleFilled style={{ color: "#ff4d4f", fontSize: 22 }} />,
      text: "Từ chối",
    },
    APPROVED: {
      icon: <CheckCircleFilled style={{ color: "#52c41a", fontSize: 22 }} />,
      text: "Đã duyệt",
    },
  };
  const config = statusConfig[status] || {};
  return (
    <div className="status-block-wrapper flex">
      {config.icon}
      {showText && <div className="status-text">{config.text}</div>}
    </div>
  );
};

StatusBlock.propTypes = {
  status: PropTypes.string,
  showText: PropTypes.bool,
};
export default StatusBlock;
